import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCmg-BofAqBpfWQHBmtyHjfNtGT-bv2l_4",
  authDomain: "soranacademy1.firebaseapp.com",
  projectId: "soranacademy1",
  storageBucket: "soranacademy1.firebasestorage.app",
  messagingSenderId: "1097432013549",
  appId: "1:1097432013549:web:aca2469e1d63d4b2194ae4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export const isFirebaseConfigured = true;

export default app;